import { v4 as uuid } from 'uuid';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { StateViewModel } from '../../models/viewModels/StateViewModel';
import { AiAgentConstants } from '../AiAgentConstants';
import { leavingAiAgentActions, enteringAiAgentActions, contentActionsAiAgent, afterStateChangedAiAgentActions, localCustomActions } from './Actions';
import { conditionOutputAiAgents } from './Outputs';
export const getAiAgentsState = (title, textContent, configuration) => {
    const id = `${AiAgentConstants.STATE_ID_PREFIX}${uuid()}`;
    const stateVersion = AiAgentConstants.CURRENT_AI_AGENTS_VERSION;
    const defaultOutput = new OutputViewModel({ stateId: id });
    return new StateViewModel({
        id,
        stateVersion,
        root: false,
        $invalid: false,
        $contentActions: contentActionsAiAgent(textContent),
        $title: title,
        $enteringCustomActions: enteringAiAgentActions(configuration),
        $leavingCustomActions: leavingAiAgentActions,
        $conditionOutputs: conditionOutputAiAgents,
        $defaultOutput: defaultOutput,
        $afterStateChangedActions: afterStateChangedAiAgentActions,
        $localCustomActions: localCustomActions,
        $toolActionsMapping: {
            builder: {
                uuid: uuid(),
            },
        },
    });
};
